import React from 'react';
import clsx from 'clsx';
import { Typography, makeStyles } from '@material-ui/core';
import { green, grey, red } from '@material-ui/core/colors';
import {
  SharedTripStatus,
  TripCompletionStatus,
  TripStatus,
} from 'src/.gen/graphql';
import { getStatusLabel } from 'src/shared/utils/tripUtils';
import { getCompletionStatuses } from 'src/shared/utils/tripStatusUtils';

interface BoxProps {
  status?: TripStatus;
  sharedStatus?: SharedTripStatus;
  iOwnThisTrip?: boolean;
}

const useStyles = makeStyles({
  tripStatusBox: {
    borderRadius: '0.3rem',
    padding: '0.2rem 0.4rem',
    marginTop: '0.8rem',
    color: green[400],
  },
  tripStatusBoxdraft: {
    color: grey[800],
  },
  tripStatusBoxcancelled: {
    color: red[400],
  },
  tripStatusBoxquoted: {
    color: '#FF9C40',
  },
  tripStatusBoxclosed: {
    color: grey[800],
  },
});

const TripStatusBox: React.FC<BoxProps> = ({
  status,
  sharedStatus,
  iOwnThisTrip,
}) => {
  const classes = useStyles();

  const showBothStatus = !getCompletionStatuses(
    TripCompletionStatus.CompleteOrClosed,
  ).includes(status);

  return showBothStatus ? (
    <Typography
      align="left"
      variant="caption"
      className={clsx(
        classes.tripStatusBox,
        classes[`tripStatusBox${status?.toLocaleLowerCase()}`],
      )}
    >
      {`${getStatusLabel(status)}`}
      {!iOwnThisTrip && ` / ${sharedStatus ?? ''}`}
    </Typography>
  ) : (
    <Typography
      align="left"
      variant="caption"
      className={clsx(
        classes.tripStatusBox,
        classes[`tripStatusBox${status?.toLocaleLowerCase()}`],
      )}
    >
      {iOwnThisTrip && getStatusLabel(status)}
      {!iOwnThisTrip && `${sharedStatus ?? ''}`}
    </Typography>
  );
};

export default TripStatusBox;
